import type { SVGProps } from 'react';
const SvgNorthEast = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#north_east_svg__a)">
      <path
        fill="currentColor"
        d="M9 5v2h6.59L4 18.59 5.41 20 17 8.41V15h2V5H9Z"
      />
    </g>
    <defs>
      <clipPath id="north_east_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgNorthEast;
